import * as React from "react";

import Tab from "./Tab";

type Props = {
  children: React.ReactNode;
  className?: string;
};

class TabControl extends React.PureComponent<Props> {
  static Tab = Tab;

  render() {
    let className = "flex list-style-none p0 m0 mb4 border-bottom border-gray";

    if (this.props.className) {
      className += " " + this.props.className;
    }

    return <ul className={className}>{this.props.children}</ul>;
  }
}

export default TabControl;
